import './App.css';
import Map from './map';

function App() {
  return (
    <div className="App">
      <Map/>
    </div>
  );
}

export default App;
